// src/utils/telegram.js
// Утилиты для работы с Telegram WebApp API

export const tg = window.Telegram?.WebApp;

export const isTelegramAvailable = () => {
    return Boolean(tg && tg.initData);
};

export const getTelegramUser = () => {
    if (tg?.initDataUnsafe?.user) {
        return tg.initDataUnsafe.user;
    }
    return null;
};

// Управление нативной кнопкой "Назад" в Telegram
export const setupBackButton = (onBackClick) => {
    if (!tg?.BackButton) return () => {};

    tg.BackButton.show();
    const handler = () => {
        if (typeof onBackClick === 'function') {
            onBackClick();
        }
    };
    tg.BackButton.onClick(handler);

    return () => {
        tg.BackButton.offClick(handler);
        tg.BackButton.hide();
    };
};

export const hideBackButton = () => {
    if (tg?.BackButton) {
        tg.BackButton.hide();
    }
};

// Всплывающие уведомления Telegram
export const showTelegramPopup = (message, title = 'Внимание', onOk) => {
    if (tg?.showPopup) {
        tg.showPopup({
            title,
            message,
            buttons: [{ type: 'ok', text: 'Понятно' }]
        }, () => {
            if (typeof onOk === 'function') onOk();
        });
    } else {
        alert(message);
        if (typeof onOk === 'function') onOk();
    }
};

// Закрытие мини-аппа
export const closeTelegramApp = () => {
    if (tg?.close) {
        tg.close();
    }
};

// Инициализация WebApp
export const ready = () => {
    if (tg) {
        tg.ready();
        tg.expand();
    }
};
